module.exports = __webpack_public_path__ + "img/pruduct-top.424448ea.jpg";